import { render, staticRenderFns } from "./DotsIcon.vue?vue&type=template&id=96ab65d8"
import script from "./DotsIcon.vue?vue&type=script&lang=js"
export * from "./DotsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports